export default {
    HISTORIAL: "historial",
    LIFEHABITS: "lifehabits",
    PHYSICALANALYSIS: "physicalanalysis"
}